module.exports = __webpack_public_path__ + "static/media/062.06e347f6.jpg";